import { createElement } from 'react'
import PropTypes from 'prop-types'

/**
 * Creates a link using the provided 'as' prop as the component.
 * It passes the 'to' prop and any additional props to the 'as' component and renders the 'children' inside it.
 *
 * @param {Object} props - The properties that define the PinataLink component.
 * @param {string} props.to - The destination URL of the link.
 * @param {ReactNode|ReactNode[]} props.children - The child or children of the PinataLink.
 * @param {function|Object} props.as - The component or object to be used as the link.
 * @returns {ReactElement} The PinataLink component.
 */
const PinataLink = ({ to, children, as: AsProp, ...props }) => createElement(AsProp, { to, ...props }, children)

PinataLink.propTypes = {
  to: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}
export default PinataLink
